import React, { useEffect, useState } from "react";
import "../css/Carousel.css";
import assets from "../assets/images";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const images = [assets.e1, assets.e2, assets.e3, assets.e4, assets.e5, assets.c6];

const texts = [
  {
    title: "Capture the Moments",
    desc: "Every photograph is more than just an image — it's a chapter in your story. From candid smiles to grand celebrations, we capture the fleeting moments that define your journey, preserving them with artistic detail and emotion.",
    button: "View Gallery",
    link: "/gallery"
  },
  {
    title: "Memories that Last",
    desc: "We don’t just take pictures — we craft memories that live on for generations. Our signature style blends authenticity and elegance, ensuring your most cherished moments are frozen in time with clarity and heart.",
    button: "Book Now",
    link: "/contact"
  },
  {
    title: "Your Story, Our Lens",
    desc: "Every couple is unique, and your story deserves to be told through a lens that understands love, emotion, and connection. We are committed to turning your once-in-a-lifetime moments into timeless visual narratives.",
    button: "Contact Us",
    link: "/contact"
  },
  {
    title: "Elegance in Every Frame",
    desc: "From the delicate lace of a bridal gown to the glint of tears in a proud parent's eyes, our lens captures it all with graceful artistry. Discover how our photography style blends sophistication and soul.",
    button: "View Gallery",
    link: "/gallery"
  },
  {
    title: "Crafting Wedding Legacies",
    desc: "A wedding is a symphony of emotions — laughter, tears, joy, and love. We orchestrate every detail into a visual legacy that will be passed down through generations, reflecting the depth and beauty of your union.",
    button: "Book Now",
    link: "/contact"
  },
  {
    title: "Artistry Beyond the Lens",
    desc: "Our photography goes beyond capturing moments — it's about expressing the soul of your celebration. Through a fine balance of creativity, professionalism, and heartfelt storytelling, we turn your vision into reality.",
    button: "Contact Us",
    link: "/contact"
  }
];

const Carousel = () => {
  const [index, setIndex] = useState(0);
  const [textVisible, setTextVisible] = useState(true);

  const goToNext = () => {
    setTextVisible(false);
    setTimeout(() => {
      setIndex((prev) => (prev + 1) % images.length);
      setTextVisible(true);
    }, 400);
  };

  const goToPrev = () => {
    setTextVisible(false);
    setTimeout(() => {
      setIndex((prev) => (prev - 1 + images.length) % images.length);
      setTextVisible(true);
    }, 400);
  };

  useEffect(() => {
    const timer = setInterval(goToNext, 6000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="carousel-container">
      {images.map((img, i) => (
        <div
          className={`carousel-slide ${i === index ? "active" : "inactive"}`}
          key={i}
          style={{ backgroundImage: `url(${img})` }}
        />
      ))}

      {/* Overlay with animated text */}
      <div className="carousel-overlay">
        <div className={`text-box ${textVisible ? "fade-slide-in" : "fade-slide-out"}`}>
          <h2 className="carousel-title">{texts[index].title}</h2>
          <p className="carousel-desc">{texts[index].desc}</p>
          <Link to={texts[index].link} className="carousel-button">
            {texts[index].button}
          </Link>
        </div>
      </div>

      {/* Arrows */}
      <div className="carousel-arrows">
        <FaChevronLeft onClick={goToPrev} className="arrow arrow-left" />
        <FaChevronRight onClick={goToNext} className="arrow arrow-right" />
      </div>

      {/* Dots */}
      <div className="carousel-dots">
        {images.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === index ? "active-dot" : ""}`}
            onClick={() => {
              setTextVisible(false);
              setTimeout(() => {
                setIndex(i);
                setTextVisible(true);
              }, 400);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
